// components/UI/Table/atoms/exportAtom.ts
import { atomFamily } from "recoil";
import { ExportExtensionEnum } from "types/enums";
import { TableId } from "types/models";

export type ExportRange = "all" | "visible";
// | "selected";

export enum ExportDelimiter {
    COMMA = ",",
    SEMICOLON = ";",
}

export interface ExportState {
    extension: ExportExtensionEnum;
    headers?: string;
    range: ExportRange;
    delimiter?: string;
}

export const exportAtom = atomFamily<ExportState, TableId>({
    key: "exportAtomFamily",
    default: {
        extension: ExportExtensionEnum.CSV,
        range: "visible",
        delimiter: ExportDelimiter.COMMA,
    },
});
